"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOfVariantImpl = void 0;
function isOfVariantImpl(key) {
    function isOfVariant(...args) {
        if (args.length === 1) {
            const [variant] = args;
            return (instance) => instance != undefined
                && Object.values(variant).some(vc => vc.output.type === instance[key]);
        }
        else if (args.length === 2) {
            const [instance, variant] = args;
            return instance != undefined
                && Object.values(variant).some(vc => vc.output.type === instance[key]);
        }
        return false;
    }
    return { isOfVariant };
}
exports.isOfVariantImpl = isOfVariantImpl;
